import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchBankAccounts_api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Payments/fetch_bank_accounts.php`);
        return response.data;
    } catch (error) {
        console.error("Fetch bank accounts failed:", error);
        return { error: "Fetch bank accounts failed" };
    }
};
